import _ from 'underscore';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx) {
    var translateFn = TranslateService.instant;

    function wrappedLoadSave(action, model) {
        var promise = action.call(undefined, model);
        return promise.then(function (submissionDTO) {
            return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
        });
    }

    var ACTION_MSG = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.flow.error.Error',
                message: 'quoteandbind.common.flow.error.An error has occurred...'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return wrappedLoadSave(LoadSaveService.saveSubmission, submission);
        }
    };

    return {
        contactDetails: function contactDetails(step, junction) {
            step('bopContactDetails', true).onNext.branch(function (model) {
                return model.quoteID.value ? 'bopPostContactDetails' : 'bopContactDetailsComplete';
            }).skipOnResumeIf(function (_ref2) {
                var submission = _ref2.value;
                return submission.persons[0] && submission.persons[0].emailAddress1;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('bopPostContactDetails').onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.saveSubmission).thenGoTo('bopContactDetailsComplete', 'error');

            junction('bopContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('bopPrequalQuestions', true).onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSG.saveSubmission).thenGoTo('bopGeneralCoverages', 'error').skipOnResumeIf(function (_ref3, _ref4) {
                var submission = _ref3.value;
                var gatewayportalnewsubmission = _ref4.gatewayportalnewsubmission;

                if (gatewayportalnewsubmission) {
                    return false;
                }

                if (submission.lobData.businessOwners && submission.lobData.businessOwners.preQualQuestionSets) {
                    var answerValues = _.values(submission.lobData.businessOwners.preQualQuestionSets[0].answers);
                    return answerValues.some(function (value) {
                        return value !== null;
                    });
                }

                return false;
            }).isValid(function (model, formValid) {
                return model.aspects.valid && model.aspects.subtreeValid && formValid.valid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Qualification');
            });

            step('bopGeneralCoverages').onNext.goTo('bopAdditionalCoverages', 'error').skipOnResumeIf(function (_ref5) {
                var submission = _ref5.value;

                var coverages = submission.lobData.businessOwners.coverages.lobCoverages;
                return submission.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.bop.wizard.step.General Coverages');
            });

            step('bopAdditionalCoverages').onNext.goTo('bopLocationsAndBuildings', 'error').skipOnResumeIf(function (_ref6) {
                var submission = _ref6.value;

                var coverages = submission.lobData.businessOwners.coverages.additionalCoverages;
                return submission.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.bop.wizard.step.Additional Coverages');
            });

            step('bopLocationsAndBuildings').onNext.goTo('bopCoverablesComplete').skipOnResumeIf(function (_ref7) {
                var submission = _ref7.value;
                return submission.baseData.periodStatus === 'Quoted';
            }).label(function () {
                return translateFn('quoteandbind.bop.wizard.step.Locations and Buildings');
            });

            junction('bopCoverablesComplete');
        },
        moreInfo: function moreInfo(step, junction) {
            step('bopPolicyInfo', true).skipOnResumeIf(function (_ref8) {
                var submission = _ref8.value;

                return submission.baseData && submission.baseData.accountHolder && submission.baseData.accountHolder.emailAddress1 && (submission.baseData.accountHolder.homeNumber || submission.baseData.accountHolder.workNumber || submission.baseData.accountHolder.cellNumber);
            }).onNext.goTo('bopMoreInfoComplete').isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Info');
            });

            junction('bopMoreInfoComplete');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/bop/config/FlowConfig.js
// module id = 1200
// module chunks = 0